var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 218 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5390_26593)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 215.465,
    width: 6.44738,
    height: 91.354,
    fill: "url(#paint1_linear_5390_26593)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99.7891,
    y: 276.367,
    width: 6.44738,
    height: 30.4513,
    fill: "url(#paint2_linear_5390_26593)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.8945,
    y: 141.512,
    width: 6.44738,
    height: 165.307,
    fill: "url(#paint3_linear_5390_26593)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.684,
    y: 224.166,
    width: 6.44738,
    height: 82.6536,
    fill: "url(#paint4_linear_5390_26593)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9473,
    y: 180.663,
    width: 6.44738,
    height: 126.156,
    fill: "url(#paint5_linear_5390_26593)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 123.738,
    y: 245.917,
    width: 6.44738,
    height: 60.9027,
    fill: "url(#paint6_linear_5390_26593)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75.8418,
    y: 171.964,
    width: 6.44738,
    height: 134.856,
    fill: "url(#paint7_linear_5390_26593)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 171.631,
    y: 119.761,
    width: 6.44738,
    height: 187.058,
    fill: "url(#paint8_linear_5390_26593)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 207.553,
    y: 276.367,
    width: 6.44738,
    height: 30.4513,
    fill: "url(#paint9_linear_5390_26593)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9746,
    y: 198.064,
    width: 6.44738,
    height: 108.755,
    fill: "url(#paint10_linear_5390_26593)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 111.762,
    y: 258.967,
    width: 6.44738,
    height: 47.8521,
    fill: "url(#paint11_linear_5390_26593)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 63.8691,
    y: 119.761,
    width: 6.44738,
    height: 187.058,
    fill: "url(#paint12_linear_5390_26593)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 159.656,
    y: 150.212,
    width: 6.44738,
    height: 156.607,
    fill: "url(#paint13_linear_5390_26593)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 195.58,
    y: 237.216,
    width: 6.44738,
    height: 69.6031,
    fill: "url(#paint14_linear_5390_26593)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9199,
    y: 163.263,
    width: 6.44738,
    height: 143.556,
    fill: "url(#paint15_linear_5390_26593)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 135.711,
    y: 237.216,
    width: 6.44738,
    height: 69.6031,
    fill: "url(#paint16_linear_5390_26593)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 87.8164,
    y: 245.917,
    width: 6.44738,
    height: 60.9027,
    fill: "url(#paint17_linear_5390_26593)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 183.605,
    y: 180.663,
    width: 6.44738,
    height: 126.156,
    fill: "url(#paint18_linear_5390_26593)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1131 98.5489C97.1131 127.628 121.42 151.201 151.403 151.201C181.387 151.201 205.693 127.628 205.693 98.5489C205.693 69.4697 181.387 45.8964 151.403 45.8964C121.42 45.8964 97.1131 69.4697 97.1131 98.5489Z",
    fill: "url(#paint19_linear_5390_26593)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 31.1578,
    ry: 30.4469,
    transform: "matrix(-1 0 0 1 104.666 135.406)",
    fill: "#C9C3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.858 114.196C131.828 107.849 118.241 97.7948 106.206 87.769C100.191 82.7576 94.5212 77.7187 89.9915 73.1297C85.5483 68.6285 81.91 64.2759 80.3044 60.6603C79.5237 58.9022 79.0538 57.1376 79.2132 55.4713C79.3882 53.6416 80.3076 52.1495 81.7971 51.1949C83.1437 50.3319 84.7457 50.0389 86.2045 49.973C87.7033 49.9054 89.3458 50.066 91.0097 50.3528C97.579 51.4853 106.148 54.8966 111.95 57.6153C113.466 58.3261 114.129 60.1035 113.43 61.5852C112.73 63.0669 110.934 63.6919 109.417 62.9811C103.745 60.3227 95.7841 57.2021 90.0545 56.2143C88.6435 55.9711 87.4758 55.8774 86.5738 55.9181C85.8025 55.9529 85.4017 56.0786 85.2323 56.1547C85.2175 56.4234 85.2863 57.0991 85.8409 58.3478C86.9596 60.867 89.878 64.5385 94.2988 69.017C98.633 73.4079 104.135 78.3047 110.073 83.2515C121.944 93.1409 135.391 103.092 144.327 109.374C144.551 109.532 144.747 109.713 144.914 109.912C144.929 109.922 144.944 109.931 144.959 109.941C153.086 115.41 166.015 123.616 178.358 130.443C184.532 133.858 190.509 136.899 195.636 139.078C200.9 141.315 204.841 142.451 207.123 142.451C208.074 142.451 208.553 142.315 208.751 142.234C208.76 142.022 208.723 141.583 208.479 140.85C208.203 140.021 207.728 139.014 207.053 137.856C204.311 133.151 199.085 127.306 195.01 123.314C193.826 122.154 193.807 120.255 194.966 119.072C196.125 117.888 198.025 117.868 199.208 119.028C203.395 123.129 209.083 129.424 212.237 134.835C213.036 136.206 213.722 137.602 214.172 138.954C214.611 140.273 214.904 141.776 214.668 143.265C214.41 144.892 213.536 146.345 211.998 147.293C210.593 148.16 208.882 148.451 207.123 148.451C203.497 148.451 198.548 146.835 193.29 144.6C187.895 142.308 181.717 139.157 175.454 135.693C162.92 128.761 149.838 120.457 141.609 114.919C141.31 114.718 141.058 114.472 140.858 114.196Z",
    fill: "#385980",
    fillOpacity: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5390_26593",
    x: 0,
    y: 0,
    width: 218,
    height: 368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5390_26593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5390_26593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5390_26593",
    x1: 222.519,
    y1: -18,
    x2: -71.9113,
    y2: 55.3696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79E4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5390_26593",
    x1: 7.22369,
    y1: 215.465,
    x2: 7.22369,
    y2: 301.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5390_26593",
    x1: 103.013,
    y1: 276.367,
    x2: 103.013,
    y2: 305.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5390_26593",
    x1: 55.1182,
    y1: 141.512,
    x2: 55.1182,
    y2: 298.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5390_26593",
    x1: 150.907,
    y1: 224.166,
    x2: 150.907,
    y2: 302.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5390_26593",
    x1: 31.171,
    y1: 180.663,
    x2: 31.171,
    y2: 300.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5390_26593",
    x1: 126.962,
    y1: 245.917,
    x2: 126.962,
    y2: 303.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5390_26593",
    x1: 79.0655,
    y1: 171.964,
    x2: 79.0655,
    y2: 299.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5390_26593",
    x1: 174.855,
    y1: 119.761,
    x2: 174.855,
    y2: 296.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5390_26593",
    x1: 210.776,
    y1: 276.367,
    x2: 210.776,
    y2: 305.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5390_26593",
    x1: 19.1983,
    y1: 198.064,
    x2: 19.1983,
    y2: 301.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5390_26593",
    x1: 114.985,
    y1: 258.967,
    x2: 114.985,
    y2: 304.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5390_26593",
    x1: 67.0928,
    y1: 119.761,
    x2: 67.0928,
    y2: 296.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5390_26593",
    x1: 162.88,
    y1: 150.212,
    x2: 162.88,
    y2: 298.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5390_26593",
    x1: 198.804,
    y1: 237.216,
    x2: 198.804,
    y2: 303.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5390_26593",
    x1: 43.1436,
    y1: 163.263,
    x2: 43.1436,
    y2: 299.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5390_26593",
    x1: 138.935,
    y1: 237.216,
    x2: 138.935,
    y2: 303.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5390_26593",
    x1: 91.0401,
    y1: 245.917,
    x2: 91.0401,
    y2: 303.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5390_26593",
    x1: 186.829,
    y1: 180.663,
    x2: 186.829,
    y2: 300.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5390_26593",
    x1: 151.403,
    y1: 45.8964,
    x2: 151.403,
    y2: 151.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.6ac2ccefc20cab92a61eb0d6baa8ccdf.svg";
export { ForwardRef as ReactComponent };